import Vue from 'vue';
import Router from 'vue-router';
// import Document from '@/components/pages/Document';
import Home from '@/components/pages/Home';
import Pronunce from '@/components/pages/Pronunce';
import Pronuncia from '@/components/pages/Pronuncia';
import Informazioni from '@/components/pages/Informazioni';
import GruppoDiLavoro from '@/components/pages/GruppoDiLavoro';
import GuidaAllUso from '@/components/pages/GuidaAllUso';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/pronunce',
      name: 'pronunce',
      component: Pronunce,
    },
    {
      path: '/pronuncia/:type/:year/:number',
      name: 'pronuncia',
      component: Pronuncia,
    },
    {
      path: '/informazioni',
      name: 'informazioni',
      component: Informazioni,
    },
    {
      path: '/gruppo-di-lavoro',
      name: 'gruppo-di-lavoro',
      component: GruppoDiLavoro,
    },
    {
      path: '/guida-all-uso',
      name: 'guida-all-uso',
      component: GuidaAllUso,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js